export const applyModalStyles = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    .layout-default__header {
      z-index: -1 !important;
      position: relative;
    }
  `;
  document.head.appendChild(style);
};

export const resetModalStyles = () => {
  const fallback = document.createElement('style');
  fallback.innerHTML = `.layout-default__header { z-index: 1000 !important; position: relative; }`;
  document.head.appendChild(fallback);
};
